module.exports = __webpack_public_path__ + "static/media/1.d634ea99.jpg";